<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-card class="box">
            <v-card-title class="headline font-weight-bold"
                style="white-space: normal; word-break: normal; line-height: 1.4;">Bulk Employee Appraisal
                Report</v-card-title>
            <v-card-text>
                <v-row justify="center">
                    <v-col cols="12" sm="6" md="3">
                        <v-autocomplete rounded required v-model="selected_ay" :items="ay_list" item-text="ay"
                            :loading="onload_loader" item-value="id" outlined>
                            <template #label>
                                Academic year <span style="color: red">*</span>
                            </template>
                        </v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                        <v-autocomplete rounded required v-model="selected_dept" :items="department_list"
                            item-text="name" item-value="id" outlined @change="getSection(); getInstructors()">
                            <template #label>
                                Department <span style="color: red">*</span>
                            </template>
                        </v-autocomplete>
                    </v-col>
                     <v-col cols="12" sm="6" md="3"
                        v-if="selected_dept && status_list && status_list.length > 0">
                        <v-autocomplete rounded v-model="selected_status" :items="status_list"
                            item-text="name" item-value="id" outlined @change="selected_section=null">
                            <template #label>
                                Status
                            </template>
                        </v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="6" md="3" v-if="selected_dept && section_list && section_list.length > 0">
                        <v-autocomplete rounded v-model="selected_section" :items="section_list"
                            item-text="name" item-value="id" outlined @change="getInstructors()">
                            <template #label>
                                Section 
                            </template>
                        </v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="6" md="4" v-show="Array.isArray(inst_list) && inst_list.length > 0">
                        <v-expand-x-transition>
                            <v-autocomplete rounded multiple required v-model="selected_inst" :items="inst_list"
                                item-text="name" item-value="id" outlined>
                                <template #label>
                                    Employee <span style="color: red">*</span>
                                </template>
                                <template v-slot:selection="{ item, index }">
                                    <v-chip v-if="index === 0">
                                        <span>{{ item.name }}</span>
                                    </v-chip>
                                    <span v-if="index === 1" class="grey--text text-caption">
                                        (+{{ selected_inst.length - 1 }} others)
                                    </span>
                                </template>
                                <template v-slot:prepend-item>
                                    <v-list-item @mousedown.prevent>
                                        <v-list-item-action>
                                            <v-checkbox v-model="selected_all_employee" @change="toggle_teacher()">
                                                <template #label><span class="ml-8">Select All</span>
                                                </template>
                                            </v-checkbox>
                                        </v-list-item-action>
                                    </v-list-item>
                                    <v-divider class="mt-2"></v-divider>
                                </template>
                            </v-autocomplete>
                        </v-expand-x-transition>
                    </v-col>

                    <v-col cols="12" sm="4" md="2" class="mt-2" align="center">
                        <v-btn color="primary" :loading="loader" @click="fetchReport">Fetch Report</v-btn>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
        <v-card class="box" v-if="parameter_details && parameter_details.length > 0">
            <v-toolbar flat dense class="toolbar">
                <v-toolbar-title>Bulk Employee Appraisal Report</v-toolbar-title>
                <v-divider class="mx-3 divider" color="white" inset vertical></v-divider>
                <v-spacer></v-spacer>
                <v-btn color="error" class="mr-2" dark small @click="generateEvaluationPdf">
                    <v-icon small left>mdi mdi-file-pdf-box</v-icon>
                    Download PDF
                </v-btn>
                <v-btn color="green" dark small @click="exportToExcel">
                    <v-icon small left>mdi-download</v-icon>
                    Export to Excel
                </v-btn>
            </v-toolbar>
            <template>
                <v-simple-table class="evaluation-table" id="exceltable">
                    <!-- <thead> -->
                    <tr>
                        <th colspan="4">Areas</th>
                        <th rowspan="2">Level of Evaluation</th>

                        <template v-for="param in parameter_details">
                            <th :colspan="param.sub_parameter_list.length">
                                {{ param.parameter_name }}
                            </th>
                        </template>

                        <th rowspan="2">Total</th>
                    </tr>

                    <tr>
                        <th>Employee Code</th>
                        <th>Employee Name</th>
                        <th>Department</th>
                        <th>Designation</th>

                        <template v-for="param in parameter_details">
                            <th v-for="sub in param.sub_parameter_list" class="text-center">
                                {{ sub.sub_parameter_name }}
                            </th>
                        </template>
                    </tr>
                    <!-- </thead> -->

                    <tbody>
                        <template v-for="emp in table_data">
                            <tr v-for="(level, i) in selfAppriasalAuthorityType_list">
                                <td v-if="i === 0" :rowspan="selfAppriasalAuthorityType_list.length">{{
                                    emp.employee_code }}</td>
                                <td v-if="i === 0" :rowspan="selfAppriasalAuthorityType_list.length">{{
                                    emp.employee_name }}</td>
                                <td v-if="i === 0" :rowspan="selfAppriasalAuthorityType_list.length">{{ emp.department
                                }}</td>
                                <td v-if="i === 0" :rowspan="selfAppriasalAuthorityType_list.length">{{ emp.designation
                                }}</td>

                                <td>{{ level.name }}</td>

                                <template v-for="param in parameter_details">
                                    <td v-for="sub in param.sub_parameter_list" class="text-center">
                                        {{
                                            emp.mark_details['Appraisal' + organization_id + ay_id + emp.inst_id +
                                            param.parameter_id + sub.sub_parameter_id + level.id]
                                        }}
                                    </td>
                                </template>

                                <td class="text-center font-weight-bold">
                                    {{
                                        emp.mark_details['Total' + organization_id + ay_id + emp.inst_id +
                                        level.id]
                                    }}
                                </td>
                            </tr>
                        </template>
                    </tbody>
                </v-simple-table>
            </template>
        </v-card>
    </div>
</template>

<script>
import axios from "axios";
import "@/assets/css/color.css";
import { table2excel } from "../../jquery.table2excel";
import jsPDF from "jspdf";
import "jspdf-autotable";
export default {
    data() {
        return {
            snackbar_msg: "",
            color: "",
            snackbar: false,
            overlay: false,
            department_list: [],
            ay_list: [],
            selected_ay: "",
            selected_dept: "",
            selected_section: "",
            selected_status:"",
            selected_inst: [],
            section_list: [],
            inst_list: [],
            selected_all_employee: false,
            parameter_details: [],
            selfAppriasalAuthorityType_list: [],
            table_data: [],
            ay_id: "",
            organization_id: "",
            loader: false,
            onload_loader: false,
            status_list: [
                { id: 0, name: "All" },
                { id: 1, name: "Working" },
                { id: 2, name: "Non Working" }
            ]
        };
    },
    methods: {
        generateEvaluationPdf() {
            try {
                const doc = new jsPDF({
                    orientation: "landscape",
                    unit: "pt",
                    format: "a3",
                });

                // First header row (Areas + Parameter groups)
                const firstRow = [
                    { content: "Areas", colSpan: 4, styles: { halign: "center", valign: "middle" } },
                    { content: "Level of Evaluation", rowSpan: 2, styles: { halign: "center", valign: "middle" } },
                ];

                // Add parameter groups with colSpan
                this.parameter_details.forEach(param => {
                    firstRow.push({
                        content: param.parameter_name,
                        colSpan: param.sub_parameter_list.length,
                        styles: { halign: "center", valign: "middle" },
                    });
                });

                firstRow.push({
                    content: "Total",
                    rowSpan: 2,
                    styles: { halign: "center", valign: "middle" },
                });

                // Second header row (sub-parameters)
                const secondRow = [
                    { content: "Employee Code" },
                    { content: "Employee Name" },
                    { content: "Department" },
                    { content: "Designation" },
                ];

                this.parameter_details.forEach(param => {
                    param.sub_parameter_list.forEach(sub => {
                        secondRow.push({ content: sub.sub_parameter_name });
                    });
                });

                // Body rows
                const body = [];
                this.table_data.forEach(emp => {
                    this.selfAppriasalAuthorityType_list.forEach((level, i) => {
                        const row = [];

                        if (i === 0) {
                            row.push({
                                content: emp.employee_code,
                                rowSpan: this.selfAppriasalAuthorityType_list.length,
                                styles: { valign: "middle", halign: "center" },
                            });
                            row.push({
                                content: emp.employee_name,
                                rowSpan: this.selfAppriasalAuthorityType_list.length,
                                styles: { valign: "middle", halign: "center" },
                            });
                            row.push({
                                content: emp.department,
                                rowSpan: this.selfAppriasalAuthorityType_list.length,
                                styles: { valign: "middle", halign: "center" },
                            });
                            row.push({
                                content: emp.designation,
                                rowSpan: this.selfAppriasalAuthorityType_list.length,
                                styles: { valign: "middle", halign: "center" },
                            });
                        }

                        row.push({ content: level.name });

                        this.parameter_details.forEach(param => {
                            param.sub_parameter_list.forEach(sub => {
                                const key = "Appraisal" +
                                    this.organization_id +
                                    this.ay_id +
                                    emp.inst_id +
                                    param.parameter_id +
                                    sub.sub_parameter_id +
                                    level.id;

                                row.push({ content: emp.mark_details[key] || "-" });
                            });
                        });

                        const totalKey =
                            "Total" + this.organization_id + this.ay_id + emp.inst_id + level.id;

                        row.push({
                            content: emp.mark_details[totalKey] || "-",
                            styles: { fontStyle: "bold" },
                        });

                        body.push(row);
                    });
                });

                // Generate table
                doc.autoTable({
                    head: [firstRow, secondRow],
                    body: body,
                    theme: "grid",
                    styles: {
                        fontSize: 6,
                        cellPadding: 1,
                        halign: "center",
                        valign: "middle",
                        overflow: "linebreak",
                    },
                    headStyles: {
                        fontSize: 6,
                        lineWidth: 0.25,
                        lineColor: [255, 255, 255], // white border
                        fillColor: [128, 128, 128], // grey background
                        textColor: [255, 255, 255], // white text
                        halign: "center",
                        valign: "middle",
                    },
                    margin: { top: 20, left: 10, right: 10 },
                    tableWidth: "auto",  // 🔥 makes table expand horizontally
                    startY: 20,
                });

                doc.save("BulkInstructorAppraisalReport.pdf");
            } catch (err) {
                console.error("PDF generation error:", err);
                this.showSnackbar("error", "Failed to generate evaluation PDF");
            }
        },

        exportToExcel() {
            $("#exceltable").table2excel({
                name: "Report Name",
                filename: "Bulk_Employee_Appraisal_Report", //do not include extension
                fileext: ".xls" // file extension
            });
        },
        onLoad() {
            this.onload_loader = true;
            axios.post("AppraisalReport/getAyAndDepartment").then((res) => {
                if (res.data.msg == "200") {
                    this.ay_list = res.data.ay_list;
                    this.department_list = res.data.department_list;
                    this.onload_loader = false;
                } else {
                    this.showSnackbar("red", res.data.msg);
                    this.onload_loader = false;
                }
                this.onload_loader = false;
            });
        },
        getInstructors() {
            const data = {
                selected_section: this.selected_section,
                selected_dept: this.selected_dept,
                selected_status: this.selected_status
            }
            this.selected_inst = [];
            this.selected_all_employee = false;
            axios.post("AppraisalReport/getInstructorListByDepartmentAndSection", data).then((res) => {
                if (res.data.msg == "200") {
                    this.inst_list = res.data.inst_list;
                } else {
                    this.showSnackbar("red", res.data.msg);
                }
            });
        },
        getSection() {
            const data = {
                selected_dept: this.selected_dept,
            }
            this.selected_inst = [];
            this.selected_all_employee = false;
            axios.post("AppraisalReport/getEmployeeSectionListByDepartment", data).then((res) => {
                if (res.data.msg == "200") {
                    // this.section_list = res.data.section_list;
                    this.section_list = [
                        { name: "All", id: 0 },
                        ...res.data.section_list
                    ];
                } else {
                    this.showSnackbar("error", res.data.msg);
                    this.section_list = [];
                    this.selected_section = "";
                }
            });
        },
        toggle_teacher() {
            this.$nextTick().then(() => {
                if (this.selected_all_employee) {
                    this.selected_inst = [];
                    for (var x in this.inst_list) {
                        this.selected_inst.push(this.inst_list[x].id);
                    }

                } else {
                    this.selected_inst = [];
                }
            });
        },
        fetchReport() {
            this.loader = true;
            const data = {
                selected_ay: this.selected_ay,
                selected_inst: this.selected_inst,
            }

            axios.post("AppraisalReport/getFacultyAppraisalReportData", data).then((res) => {
                if (res.data.msg == "200") {
                    this.selfAppriasalAuthorityType_list = res.data.selfAppriasalAuthorityType_list;
                    this.parameter_details = res.data.parameter_details;
                    this.table_data = res.data.table_data;
                    this.ay_id = res.data.ay_id;
                    this.organization_id = res.data.organization_id;
                    this.loader = false;
                } else {
                    this.showSnackbar("error", res.data.msg);
                    this.loader = false;
                }
            });
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
    },
    mounted() {
        this.onLoad();

    },
};
</script>

<style scoped>
.evaluation-table th,
.evaluation-table td {
    border: 1px solid #ccc;
    padding: 6px;
    font-size: 12px;
    text-align: center;
}

.evaluation-table th {
    background-color: #E8EAF6;
}
</style>